import { PromoBasketPopupActionTypes } from '../../../enums/ActionEnums';
export const promoBasketPopupActions = {
    createInitializeAction: () => ({
        type: PromoBasketPopupActionTypes.INIT,
    }),
    createPopupCloseAction: () => ({
        type: PromoBasketPopupActionTypes.POPUP_CLOSE,
    }),
    createPopupOpenAction: (message) => ({
        type: PromoBasketPopupActionTypes.POPUP_OPEN,
        payload: message,
    }),
};
